import { FlowCall, Condition, getFlowElement, VALIDATION_TYPES, EFFECTS, IconNames, FORM_ELEMENT_TYPES } from 'prace-common-components'

/* Partition-select elements store the partition id as their condition value.
 * Resolve that id to the partition name so conditions never display a raw id. */
export const getConditionValueLabel = (
  call: FlowCall, elementId: Nullable<number>, value: Nullable<StringNumber>,
): StringNumber => {
  if(value == null) return ''
  const { element } = getFlowElement(call, elementId)
  if(element?.elementType !== FORM_ELEMENT_TYPES.SELECT_PARTITION) return value
  for(const cutOff of call.cutoffs) {
    const resource = cutOff.resources.find((res) => res.partition?.id == value)
    if(resource) return resource.partition.name
  }
  return value
}

export const conditionText = (call: FlowCall, cond: Condition): string[] => {
  const { validation } = cond
  const { elements, type, values } = validation
  return elements.map((flowElement: {id: number}) => {
    const { element } = getFlowElement(call, flowElement.id)
    const valuesLength = values.length
    const validConditionType = type && (type !== VALIDATION_TYPES.UNCONDITIONAL)
    const valueLabel = (idx: number) => getConditionValueLabel(call, flowElement.id, values[idx])
    const conditionTypeText = type === VALIDATION_TYPES.REQUIRED ?
      ` > ${type}` :
      ` > ${type} ${valuesLength > 1 ?`> [${valueLabel(0)}, ${valueLabel(1)}]` : valuesLength ? `> ${valueLabel(0)}` : ''}`

    return `${element?.title}` + (validConditionType ? conditionTypeText : '')
  })
}

export const conditionIcon = (effect: EFFECTS): string => {
  switch(effect) {
    case EFFECTS.EDITABLE:
      return 'altEdit'
    case EFFECTS.REQUIRED:
      return 'required'
    case EFFECTS.VISIBLE:
      return 'change_visibility'
    case EFFECTS.SUM:
      return 'add-circle'
    default:
      return 'valid'
  }
}

export const conditionsToolTips = (call: FlowCall, conds: Condition[]) => {
  /* Group conditions by effect type */
  const groupedConds = []
  for (const effect in EFFECTS) {
    const filteredConds = conds.filter((cond) => cond.effect == EFFECTS[effect as keyof typeof EFFECTS])
    if(filteredConds.length)
      groupedConds.push({
        text: filteredConds.map((cond) => '- ' + conditionText(call, cond).join('\n  ')).join('\n'),
        icon: conditionIcon(EFFECTS[effect as keyof typeof EFFECTS]),
      })
  }
  return groupedConds
}

const getSubTitle = (validation: Condition['validation'], elementNames: string[]) => {
  return (validation.elements.length < 2 && validation.type) ?
    elementNames[0] : `${validation.elements.length} elements`
}

export const getConditionCardProps = (call: FlowCall, condition: Condition) => {
  const icon = conditionIcon(condition.effect)
  const { validation } = condition

  const elementNames = conditionText(call, condition)
  const subTitle = getSubTitle(validation, elementNames)

  return {
    icon: icon as IconNames,
    title: condition.effect || '',
    subTitle,
    tooltipText: elementNames.join('\n'),
  }
}
